import { useMutation, useQueryClient } from "react-query";
import { notifications } from "@mantine/notifications";

import { editCustomView } from "modules/core/api/custom_views";

import { CUSTOM_VIEWS_QUERY_KEY } from "../../queries/useCustomViewsQuery";

export const useUpdateCustomViewMutation = () => {
  const queryCLient = useQueryClient();

  return useMutation({
    mutationFn: editCustomView,

    onSuccess: () => {
      notifications.show({
        message: "Custom view updated",
        color: "green",
        variant: "light"
      });
    },

    onError: () => {
      notifications.show({
        message: "Failed to update custom view",
        color: "red",
        variant: "light"
      });
    },

    onSettled: () => {
      queryCLient.invalidateQueries(CUSTOM_VIEWS_QUERY_KEY);
    }
  });
};
